import { HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from '@core/providers/http/api.service';
import { Observable } from 'rxjs';
import { map, debounceTime } from 'rxjs/operators';
import { InstituicaoEnsino } from '../models/instituicao-ensino.model';
@Injectable({
  providedIn: 'root'
})
export class InstituicaoEnsinoService {
  private readonly path = 'bolsa';
  public params = new HttpParams();

  constructor(private apiService: ApiService) {}

  // List all instituicoes de ensino
  list(params?: any): Observable<any> {
    return this.apiService.get<{ data: InstituicaoEnsino[] }>(`${this.path}/getAllInstituicaoEnsino`, params ? new HttpParams({
      fromObject: params
    }) : this.params).pipe(
      // debounceTime(500),
      map(response => response)
    );
  }

  // Get instituicao de ensino by ID
  public show(id: any): Observable<InstituicaoEnsino> {
    return this.apiService.get<{ data: InstituicaoEnsino, retorno: any }>(`${this.path}/getInstituicaoEnsinoById/${id}`).pipe(
      map(response => response.data as InstituicaoEnsino)
    );
  }

  public store(formData: FormData): Observable<any> {
    return this.apiService.post(`${this.path}/AddInstituicaoEnsino`, formData);
  }

  // Update existing instituicao de ensino
  public update(formData: FormData, id: string): Observable<any> {
    return this.apiService.put(`${this.path}/UpdateInstituicaoEnsino/${id}`, formData)
  }
  
  // Toggle status of instituicao de ensino
  public toggleStatus(id: string): Observable<InstituicaoEnsino> {
    return this.apiService
      .patch<{ object: InstituicaoEnsino }>(`${this.path}/ToogleInstituicaoEnsinoStatus/${id}`, {})
      .pipe(
        map((response) => response.object as InstituicaoEnsino)
      );
  }

  // Delete existing instituicao de ensino
  public delete(id: string): Observable<any> {
    return this.apiService.delete(`${this.path}/DeleteInstituicaoEnsinoById/${id}`);
  } 
  
  // Get Photo instituicao de ensino
  getFotoInstituicaoById(id: number): Observable<Blob> {
    return this.apiService.get(`${this.path}/GetInstituicaoEnsinoFotoById/${id}`,
      new HttpParams(),
      false,
      'blob',
    );
  }

  /*
  updateFotoInstituicaoEnsino(data: FormData, id: string) {
    return this.apiService.put<any>(
      `${this.path}/UpdateInstituicaoEnsinoLogotipo/${id}`, data); // Assumindo que seu serviço estende BaseService
  }*/
}
